import React, { ReactNode } from 'react';
import { NotificationProvider } from '../../contexts/NotificationContext';
import ProtectedRoute from '../protectedRoute';

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

/**
 * Layout que envolve páginas autenticadas com NotificationProvider
 * Garante que notificações só sejam carregadas quando usuário está logado
 */
const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ children }) => {
  return (
    <ProtectedRoute>
      <NotificationProvider>
        {children}
      </NotificationProvider>
    </ProtectedRoute>
  );
};

export default AuthenticatedLayout;
